'use strict';

class ClientsController {
    /* @ngInject */
    constructor(ClientsService, $scope, $q) {
        Object.assign(this, {ClientsService, $scope, $q});

        this.query = {
            limit: 25,
            page: 1
        };
        //this.clients = $scope.$parent.$resolve.clients;
        this.getClients();

        this.onPagination = () => {
            this.getClients();
        };

        this.clientIds = null;
    }

    onClientFilterUpdate($event) {
        let clientsPromise = $event.clientsPromise;
        clientsPromise.then(clients => {
            this.clientIds = clients ? clients.map(c => c.id) : null;
            this.getClients();
        });
    }

    getClients() {
        let opts = {
            page: this.query.page,
            limit: this.query.limit,
            where: {}
        };

        opts.where = Object.assign(opts.where, {
            ...(this.clientIds ? {
                id: {
                    inq: this.clientIds
                }
            }: null)
        });

        let queryReady = this.ClientsService
            .getModels(opts)
            .then(clients => {
                this.clients = clients;
            });
        let countReady = this.ClientsService
            .getCount(opts)
            .then(result => {
                this.clientsCount = result.count;
            });
        this.promise = this.$q.all([queryReady, countReady]);
        return this.promise;
    }

}

export default ClientsController;
